<script>
import baseEdit from '@/views/components/base/baseEdit.vue'
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: 'squad',
      key: 'squad_id',
      items: [
        { label: '团队信息', desc: '团队基本信息', type: 'header' },
        { label: '父级', name: 'pid', value: 0, type: 'tree', dropList: [{ value: 0, name: '顶级分类' }], rules: [{ required: true, trigger: 'blur', type: 'number' }] },
        { label: '团队名', name: 'name', value: '', type: 'input', rules: [{ required: true, trigger: 'blur' }] },
        { label: '权限控制', desc: '团队权限信息', type: 'header' },
        { label: '加水权限', name: 'is_water', value: 1, type: 'switch', trueValue: 1, falseValue: 0 },
        { label: '回声树权限', name: 'is_tree', value: 1, type: 'switch', trueValue: 1, falseValue: 0 },
        { label: '创建回声树', name: 'is_add_tree', value: 1, type: 'switch', trueValue: 1, falseValue: 0 },
        { label: '备注', name: 'remark', value: '', type: 'textarea' },
      ],
      forms: {},
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      let q = {}
      q.pid = 0
      let res = await $utils.api.load('admin/api/squad/dropTree', q)
      if (res.code == 1) {
        let data = res.data
        let dropList = [{ value: 0, name: '顶级分类' }]
        for (let i = 0; i < data.length; i++) {
          dropList.push({ value: data[i].id, name: data[i].name })
        }
        this.items[1].dropList = dropList
      }
    },
    // initData() {
    //   // 加载详情数据
    //   $form.initData(this, {}, (res) => {
    //     if (res) {
    //       this.forms = res;
    //       this.$forceUpdate();
    //       console.log("initData formsxxxxxxxxxxxxx", this.forms);
    //       if (this.forms.group_ids) {
    //         this.forms.group_ids = this.forms.group_ids.split(",");
    //       }
    //     }
    //   });
    // },
    // handleSubmit() {
    //   this.$refs.form.validate((valid) => {
    //     console.log("handleSubmit forms", valid, this.forms);
    //     if (valid) {
    //       this.forms.title = this.forms.user_nick;
    //       $form.handleSubmit(this);
    //     }
    //   });
    // },
  },
}
</script>
